import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createPriceBand } from 'src/api/createPriceBand/createPriceBand';
import { ICreatePriceBandBody } from 'src/api/createPriceBand/types';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { QueryKeys } from '../QueryKeys';

export const useCreatePriceBand = (onMutationSuccess: () => void, priceSchemeId: string) => {
  const queryClient = useQueryClient();
  const { showSnackbar } = useSnackbar();

  return useMutation(async (requestBody: ICreatePriceBandBody) => await createPriceBand(requestBody, priceSchemeId), {
    onSuccess: async (_, variables) => {
      await queryClient.invalidateQueries({ queryKey: [getBrandId(), QueryKeys.priceBands] });
      showSnackbar({
        message: `You have successfully created price band ${variables.name}.`,
        status: SnackbarStatus.SUCCESS,
      });
      onMutationSuccess();
    },
    onError: () => {
      showSnackbar({
        message: 'Something went wrong whilst creating a price band.',
        status: SnackbarStatus.ERROR,
      });
    },
  });
};
